import { createUseStyles } from 'react-jss';

const styles = {
  switchContainer: {
    '& ui5-button': {
      margin: '0 0.3rem'
    },
    display: 'flex',
    padding: '0.5rem',
    justifyContent: 'End',
    alignItems: 'Center'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'HistoryCommentsSwitch'
});
